<script lang="ts" setup>
import { computed } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

type LabelType = "success" | "notice" | "danger";

const props = defineProps({
  type: {
    type: String as () => LabelType,
    default: "notice"
  },
  text: {
    type: String,
    required: true
  }
});

const icon = computed(
  () =>
    ({
      success: "check-circle",
      notice: "circle",
      danger: "alert-circle"
    }[props.type] || "")
);
const labelClass = computed(
  () =>
    ({
      success: "text-green",
      notice: "text-yellow",
      danger: "text-red"
    }[props.type] || "text-primary")
);
</script>

<template>
  <div class="d-flex justify-content-end align-items-center">
    <FeatherIcon v-if="icon" :icon="icon" size="1x" :class="labelClass" />
    <p class="text-size-14 ml-1" :class="labelClass" data-testid="label">
      {{ text }}
    </p>
  </div>
</template>
